import { CALL_API, Schemas } from '../../common/middleware/api';

export const DOCUMENT_FORMS_REQUEST = 'DOCUMENT_FORMS_REQUEST';
export const DOCUMENT_FORMS_SUCCESS = 'DOCUMENT_FORMS_SUCCESS';
export const DOCUMENT_FORMS_FAILURE = 'DOCUMENT_FORMS_FAILURE';

export const DOCUMENT_FORM_FETCH_REQUEST = 'DOCUMENT_FORM_GET_REQUEST';
export const DOCUMENT_FORM_FETCH_SUCCESS = 'DOCUMENT_FORM_GET_SUCCESS';
export const DOCUMENT_FORM_FETCH_FAILURE = 'DOCUMENT_FORM_GET_FAILURE';

export const DOCUMENT_FORM_CREATE_REQUEST = 'DOCUMENT_FORM_CREATE_REQUEST';
export const DOCUMENT_FORM_CREATE_SUCCESS = 'DOCUMENT_FORM_CREATE_SUCCESS';
export const DOCUMENT_FORM_CREATE_FAILURE = 'DOCUMENT_FORM_CREATE_FAILURE';

export const DOCUMENT_FORM_UPDATE_REQUEST = 'DOCUMENT_FORM_UPDATE_REQUEST';
export const DOCUMENT_FORM__UPDATE_SUCCESS = 'DOCUMENT_FORM_UPDATE_SUCCESS';
export const DOCUMENT_FORM_UPDATE_FAILURE = 'DOCUMENT_FORM_UPDATE_FAILURE';

export const loadDocumentForms = (options) => ({
	[CALL_API]: {
		types: [DOCUMENT_FORMS_REQUEST, DOCUMENT_FORMS_SUCCESS, DOCUMENT_FORMS_FAILURE],
		endpoint: 'api/documentForms',
		request: options,
		schema: Schemas.DOCUMENT_FORM_ARRAY
	}
});

export const fetchDocumentForm = (id) => ({
	[CALL_API]: {
		types: [DOCUMENT_FORM_FETCH_REQUEST, DOCUMENT_FORM_FETCH_SUCCESS, DOCUMENT_FORM_FETCH_FAILURE],
		endpoint: `api/documentForms/${id}`,
		schema: Schemas.DOCUMENT_FORM
	}
});

export const createDocumentForm = (documentForm, history) => ({
	[CALL_API]: {
		types: [DOCUMENT_FORM_CREATE_REQUEST, DOCUMENT_FORM_CREATE_SUCCESS, DOCUMENT_FORM_CREATE_FAILURE],
		endpoint: 'api/documentForms',
		method: 'POST',
		request: documentForm,
		schema: Schemas.DOCUMENT_FORM,
		form: 'documentForm',
		transition: {
			history,
			successPath: (response) => {
				return `/documentForms`;
			}
		}
	}
});

export const updateDocumentForm = (id, documentForm) => ({
	[CALL_API]: {
		types: [DOCUMENT_FORM_UPDATE_REQUEST, DOCUMENT_FORM__UPDATE_SUCCESS, DOCUMENT_FORM_UPDATE_FAILURE],
		endpoint: `api/documentForms/${id}`,
		method: 'PUT',
		request: documentForm,
		schema: Schemas.DOCUMENT_FORM,
		form: 'documentForms'
	}
});